export default __webpack_public_path__ + "images/60aa99a42c5e359514fe235c7b66dc7f-7316_NIYT_home_header_4K_1920x544.jpg";